import '../styles/signinstyle.css'
import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { Divider } from '@material-ui/core';

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export class PasswordReset extends Component {
    constructor(props) {
        super(props);
        this.state = {
            newpassword1: "",
            newpassword2: "",
            passwordresetrandom: "",
            title: "Reset Password"
        };

        localStorage.removeItem("authtoken");
    }

    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }

    componentDidMount() {
        //this.checkForLogin();
        //this.loginAction();
        this.setState({
            passwordresetrandom: this.props.match.params.randomtoken
        });
    }

    checkForLogin = () => {

        // setter
        //localStorage.setItem("authtoken", 555888);
        //// getter
        //localStorage.getItem('myData');
        //// remove
        //localStorage.removeItem('myData');
        //// remove all
        //localStorage.clear();
    }

    //handleInputChange = e => {
    //    let tmpformdatas = this.state.formdatas;
    //    tmpformdatas[e.target.name] = e.target.value;
    //    this.setState({
    //        formdatas: tmpformdatas
    //    });
    //};

    resetPassword = (event) => {
        event.preventDefault();

        fetch(global.variables.API_USEROPERATIONS_PASSWORDRESET, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(this.state)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                if (result.resultstate == 0) {
                    window.location.href = "/login";
                } else {
                    toast.error("Failed!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                }
            });
    };

    render() {
        const { newpassword1, newpassword2 } = this.state
        return (
            <div className="romis-signin-bg">
                <Grid>
                    <ToastContainer />
                </Grid>
                <Grid container direction="row" justify="center" alignItems="center" >

                    <Card className="romis-img-card">
                        <div style={{ textAlign: "center", float: "left", paddingTop: 50 }}>
                            <img src="/images/financed.png" alt="" width="183px" height="93px" />
                            <Typography variant="caption" display="block" gutterBottom >
                                This project is co-financed by the European Union
                            </Typography>
                            <Typography variant="caption" display="block" gutterBottom >
                                and the Republic of Turkey.
                            </Typography>
                        </div>
                        <Divider orientation="vertical" />
                        <div style={{ textAlign: "center", float: "right" }}>

                            <img src="/images/rom_dark.png" alt="" width="384px" height="216px" />

                        </div>
                    </Card>

                </Grid>
                <Grid container direction="row" justify="center" alignItems="center" >

                    <Card style={{ maxHeight: 350 }}>
                        <CardHeader title="Reset Password" className='romis-card-header' />
                        <CardContent>
                            <Typography variant="subtitle1" gutterBottom>Please enter your password</Typography>
                            <Grid item>
                                <TextField
                                    label="Enter Your Password:"
                                    placeholder="Password"
                                    margin="normal" fullWidth
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    value={newpassword1}
                                    onChange={this.handleChange.bind(this)}
                                    name="newpassword1"
                                    type="password"
                                />
                            </Grid>
                            <Grid item>
                                <TextField
                                    label="Re-Enter Your Password:"
                                    placeholder="Password"
                                    margin="normal"
                                    fullWidth
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    value={newpassword2}
                                    onChange={this.handleChange.bind(this)}
                                    name="newpassword2"
                                    type="password"
                                />
                            </Grid>
                            <Grid item style={{ textAlign: "center" }}>
                                <Button variant="contained" color="primary" onClick={this.resetPassword.bind(this)}> Reset </Button>
                            </Grid>
                        </CardContent>
                    </Card>

                </Grid>
                <Grid>
                    <div align="center">
                        <img src="/images/cfcu.png" alt="" width="62px" height="66px" />
                        <img src="/images/eptisa.png" alt="" width="105px" height="80px" style={{ marginLeft: 120, marginRight: 120 }} />
                        <img src="/images/europan.png" alt="" width="46px" height="46px" />
                    </div>
                </Grid>
            </div>
        );
    }
}





// WEBPACK FOOTER //
// ./src/pages/PasswordReset.js